// src/utils/api.js

/** Base URL del API. En dev en el mismo PC, apunta directo a :8000 (evita HTML del proxy). */
export function getApiBase() {
  const fromEnv = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || "";
  if (fromEnv) return fromEnv.replace(/\/$/, "");

  if (process.env.NODE_ENV === "development" && typeof window !== "undefined") {
    const { hostname, protocol } = window.location;
    // Solo en el PC local: conexión directa al backend.
    // En tablet/móvil (IP de red) usamos URLs relativas → proxy de `npm start` → :8000.
    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return `${protocol}//127.0.0.1:8000`;
    }
  }

  return "";
}

const API_BASE = getApiBase();

export default async function apiFetch(path, options = {}) {
  const url =
    path.startsWith("http://") || path.startsWith("https://")
      ? path
      : `${API_BASE}${path}`;

  return fetch(url, options);
}

/** Parsea JSON de una Response; falla con mensaje claro si el servidor devolvió HTML. */
export async function safeJson(res) {
  const contentType = (res.headers.get("content-type") || "").toLowerCase();
  if (!contentType.includes("application/json")) {
    const text = await res.text();
    if (/^\s*</.test(text)) {
      throw new Error(
        "No se pudo conectar con la API. Comprueba que el backend está en marcha (puerto 8000) y actualizado."
      );
    }
    throw new Error(text.slice(0, 160) || `Respuesta inesperada (${res.status})`);
  }
  return res.json();
}

export function apiErrorDetail(data, fallback = "Error en la API") {
  const detail = data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => d.msg || String(d)).join(", ");
  }
  return fallback;
}
